import { ResponsiveUtils } from "@sazka/utils/responsive-utils";

document.ready(() => {
    if (ResponsiveUtils.isIos()) {
        $(".android-only").hide();
    }

    if (ResponsiveUtils.isAndroid()) {
        $(".ios-only").hide();
    }
});
